import axios from 'axios'

export default {
    getAll: () => axios.get('/attr'),
    getByCategory: id => axios.get(`/attr/${id}`)
}
